import 'jquery';
import { listenToAnchorClicks } from '../../src/funding_overview/funding_overview';
import '../../src/funding_overview/funding_overview.scss';

listenToAnchorClicks();
